__turbopack_context__.v({
  "button": "BubbleButton-module-scss-module__C8qEZa__button",
  "highlight": "BubbleButton-module-scss-module__C8qEZa__highlight",
  "icon": "BubbleButton-module-scss-module__C8qEZa__icon",
  "root": "BubbleButton-module-scss-module__C8qEZa__root",
});
